import {IconButtonProps} from "@mui/material";
import {TooltippedIconButton} from "../button/TooltippedIconButton";

export interface SectionActionButtonProps {
    icon: JSX.Element;
    tooltip?: string;
    onClick: () => void;
    disabled?: boolean;
    visible?: boolean;
    color?: IconButtonProps["color"];
}

export function SectionActionButton(props: Readonly<SectionActionButtonProps>) {
    const {visible = true, ...iconButtonProps} = props;
    if (!visible) {
        return null;
    }

    return (
            <TooltippedIconButton
                    color={"primary"}
                    size={"small"}
                    {...iconButtonProps}/>
    );
}